export default __webpack_public_path__ + "static/media/esterella5.87ec20d8.jpg";